import { useState } from 'react'
import classNames from 'classnames'
import Slider from 'react-slick'
import { Modal } from 'react-bootstrap'

import { CarouselNext } from 'component/Common/CarouselNext'
import { CarouselPrev } from 'component/Common/CarouselPrev'

import styles from './styles.module.scss'


export const ProfessorsV2 = props => {
  const { data } = props
  const columbiaUniData = data?.professors?.find((item) => item?.id === 'columbia-university')
  const carouselData = data?.professors?.filter((item) => item?.id !== 'columbia-university')

  const [activeModalData, setActiveModalData] = useState(null)
  const [showModal, setShowModal] = useState(false)

  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 2,
    slidesPerRow: 2,
    nextArrow: <CarouselNext iconClassName={classNames(styles.arrow, 'btn btn-primary-gradient')} />,
    prevArrow: <CarouselPrev iconClassName={classNames(styles.arrow, 'btn btn-primary-gradient')} />,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesPerRow: 1,
        }
      },
    ]
  };

  const openModal = (data) => {
    setActiveModalData(data)
    setShowModal(true)
  }

  const closeModal = () => {
    setShowModal(false)
    setActiveModalData(null)
  }

  return (
    <>
      <div className="row mt-50">
        <div className="col-12 col-lg-4">
          <div className={classNames(styles.card, styles.cardMain, 'bg-blue-gradient')}>
            {columbiaUniData?.svg}
            <div className={classNames(styles.cardHeader, 'mt-30 text-white')}>
              <div className={styles.meta}>
                <h5 className={classNames(styles.name, 'mb-30 ')}>{columbiaUniData?.name}</h5>
                <p className={styles.desc}>{columbiaUniData?.desc}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-8 mt-30 mt-lg-0">
          <Slider {...settings} className={styles.profSlider}>
            {carouselData.map((item) => (
              <div key={item.id} className={styles.slideItem}>
                <div className={styles.card}>
                  <div className={styles.cardHeader}>
                    <img src={item.img.src} alt={item.img.alt} className={styles.profImg} />
                    <div className={styles.meta}>
                      <h5 className={styles.profName}>{item.name}</h5>
                      {item.orgLogo &&
                        <img src={item.orgLogo} alt="logo" className={styles.profLogo} />
                      }
                    </div>
                  </div>
                  <div className={styles.cardBody}>
                    <p className={styles.profDesc}>{item.desc}</p>
                    <button
                      className={styles.learnMoreBtn}
                      onClick={() => openModal(item)}
                    >
                      Learn More
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>

      {/* Modal */}
      <Modal
        show={showModal}
        onHide={closeModal}
        id="professorModal"
        centered
        dialogClassName="modal-dialog-centered"
      >
        <Modal.Header closeButton>
          <Modal.Title id="professorModalLabel">{activeModalData?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {activeModalData?.img && (
            <img
              src={activeModalData.img.src}
              alt={activeModalData.img.alt}
              className="img-fluid mb-3"
            />
          )}
          <p>{activeModalData?.desc}</p>
        </Modal.Body>
      </Modal>
    </>
  )
}
